import { render, staticRenderFns } from "./WrapScroll.vue?vue&type=template&id=ca222d04&"
import script from "./WrapScroll.vue?vue&type=script&lang=js&"
export * from "./WrapScroll.vue?vue&type=script&lang=js&"
import style0 from "./WrapScroll.vue?vue&type=style&index=0&id=ca222d04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports